<div class="content content-more-margin desktop-wide">
  <h1>{{ i18n.langString("note_for_us_residents") }}</h1>
  <p>
    <a
      class="link-underline"
      href="https://www.henkel-adhesives.com/us/en.html"
      target="_blank"
      >{{ i18n.langString("website_link") }}</a
    >
  </p>
  <p>
    <a
      class="link-underline"
      href="https://www.henkel-adhesives.com/us/en.html"
      target="_blank"
      >{{ i18n.langString("learn_more_link") }}</a
    >
  </p>
  <p>
    {{ i18n.langString("note_website_content") }}
  </p>
  <div class="back-btn">
    <app-nav-button
      [darksecondary]="true"
      svgIcon="icons:arrow-left"
      (clickEvent)="gotoLogin()"
      >{{ i18n.langString("back") }}
    </app-nav-button>
  </div>
  <app-scroll-to-top></app-scroll-to-top>
</div>
